"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const radio_1 = require("components/cosmos/radio");
const inputCardRadio_module_scss_1 = __importDefault(require("./inputCardRadio.module.scss"));
const InputCardRadio = ({ title, id, name, value, children, isDisabled = false, isChecked = false, className, onChange }) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.target.firstChild.click();
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { role: "button", tabIndex: 0, className: (0, classnames_1.default)(inputCardRadio_module_scss_1.default.container, className, {
            '_border-gray-200 _bg-white': !isChecked && !isDisabled,
            '_border-blue-light _bg-blue-lightest _shadow-sm': isChecked,
            '_border-gray-300 _bg-gray-200 _shadow-none _cursor-not-allowed': isDisabled,
            [inputCardRadio_module_scss_1.default.disabled]: isDisabled
        }, '_h-full _rounded-lg _border _cursor-pointer'), "aria-label": title, onKeyDown: handleKeyDown, children: (0, jsx_runtime_1.jsxs)("label", { id: `label-card-${value}`, htmlFor: id, className: (0, classnames_1.default)('_text-2 _text-left _text-gray-500 _line-height-lg _mt-0 _mb-0 _p-4', { '_cursor-pointer': !isDisabled }, { '_cursor-not-allowed': isDisabled }), children: [(0, jsx_runtime_1.jsx)(radio_1.Radio, { className: (0, classnames_1.default)('_mt-0 _text-2 _text-left _font-weight-bold _text-gray-700', { '_mb-3': children, ' _mb-0': !children }), id: id, name: name, value: value, checked: isChecked, label: title, onChange: onChange, disabled: isDisabled }), children] }) }));
};
exports.default = InputCardRadio;
